export const RouterName = {
    "所有教学活动模块":"所有教学活动模块",
    "我的表现":"我的表现",
    "表现":"表现",
    '选择活动类型':"选择活动类型",
    "星星":"星星",
    "奖励":"奖励",
    "扣除":"扣除",
    "新建":"新建",
    '奖励星星':"奖励星星",
    "扣除星星":"扣除星星",
    "新建活动类型":"新建活动类型",
    "请选择星星数":'请选择星星数',
    "请输入星星数":'请输入星星数',
    "选择分组批次":"选择分组批次",
    "排行榜":"排行榜",
    "课程人数":"课程人数",
    "星星统计星":"星星统计(星)",
    "参与人数统计人":"参与人数统计(人)",
    "星星卡活动":"星星卡活动",
    "其他活动":"其他活动",
    "表现统计":"表现统计",
    "总星星":"总星星",
    "第一小组":"第一小组",
    "参与活动":"参与活动",
    "星":"星",
    "平台活动":"平台活动",
    "当前排名":"当前排名：",
    "总星星数":"总星星数",
    "此星星卡有效可以使用":"此星星卡有效，可以使用",
    "星星卡":"星星卡",
    "返回首页":"返回首页",
    "此星星卡无效":"此星星卡无效",
    "已被学生":"已被学生",
    "于":"于",
    "扫描了":"扫描了",
    "请选择活动类型":"请选择活动类型",
    "查看表现":"查看表现",
    "扫码失败":"扫码失败",
    "请选择一个活动类型":"请选择一个活动类型",
    "当前排行":"当前排行",
    "参与活动数":"参与活动数",
    "得星记录":"得星记录",
    "今日表现榜":"今日表现榜",
    "总表现榜":"总表现榜",
    "按姓名排序":"按姓名排序",
    "按得星数排序":"按得星数排序",
    "按学号排序":"按学号排序",
    "继续奖励":"继续奖励",
    "批量奖励":"批量奖励",
    "操作成功":"操作成功",
    "自定义":"自定义",
    
}